import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial, useStylesAutoBlack,
} from '../../../../../St/Reports/UseStyle';
import { insh as inshst } from "../../../../../Context/InshSt";
import AccountSelect from '../../../../../components/controls/accounts-select';
import { Button, colors } from '@material-ui/core';
import { Save } from '@material-ui/icons';
import { useTranslation } from "react-i18next";


export default function InvoicesExpensesForm(props) {

    const {
        onChangeSub,
        onChangeAutoSub,
        paramsAutoSub,
        AutoOptions,
        onSubmit,
        paramsSub,
        gets
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAutoBlack();
    const clasTF = useStylesTF();
    const clasui = useStylesUiElemment();
    const { t } = useTranslation(["forms", "translation"]);
    const handleFocus = (e) => e.target.select();

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={3} md={4} sm={8} xs={12}>
                    <AccountSelect
                        accounts={AutoOptions?.Accindex}
                        account={paramsAutoSub.Expense_Acc_no}
                        onSelect={(newValue) => {
                            onChangeAutoSub("Expense_Acc_no", newValue);
                            document.getElementById("value").focus()
                        }}
                    />
                </Grid>

                <Grid item lg={2} md={3} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="value"
                        label={t("value")}
                        type="number"
                        className={clasTF.rootCust}
                        onFocus={handleFocus}
                        // disabled={!prevent && !openUpdate ? true : paramsSub?.credit > 0 ? true : false}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{
                            className: claslbl.clrBlackTxt,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    document.getElementById("notes").focus();
                                }
                            },
                        }}
                        name="dept"
                        value={paramsSub.Expense_value}
                        onChange={onChangeSub("Expense_value")} />
                </Grid>


                <Grid item lg={2} md={3} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="notes"
                        label={t("note")}
                        type="text"
                        className={clasTF.rootCust}
                        // disabled={!prevent && !openUpdate ? true : false}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        onFocus={handleFocus}
                        InputProps={{
                            className: claslbl.clrBlackTxt,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onSubmit(event);
                                }
                            },
                        }}
                        name="notes" value={paramsSub.Expense_Note}
                        onChange={onChangeSub("Expense_Note")} />
                </Grid>
                <Grid container item lg={4} md={5} sm={7} xs={12} spacing={1} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>

                    <Grid item lg={4} md={4} sm={4} xs={4} style={{ paddingBottom: "0.5rem" }}>
                        <Autocomplete
                            classes={clasTF}
                            value={paramsAutoSub.omla}
                            onChange={(event, newValue) => {
                                onChangeAutoSub("omla", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={gets?.omlats}
                            disableClearable={true}
                            // disabled={!prevent && !openUpdate ? true : false}
                            style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            renderInput={(params) => (
                                <TextField
                                    id="center"
                                    {...params}
                                    label={t("currency")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={4} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="credit"
                            label={t("curr-exchange")}
                            type="number"
                            className={clasTF.rootCust}
                            onFocus={handleFocus}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            name="credit"
                            value={paramsSub?.omlaval}
                            onChange={onChangeSub("omlaval")} />
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={4} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="credit"
                            label={t("curr-local")}
                            type="number"
                            className={clasTF.rootCust}
                            disabled={true}
                            onFocus={handleFocus}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            name="credit"
                            value={((Number(paramsSub.Expense_value) ) * Number(paramsSub.omlaval)).toFixed(2)} />
                    </Grid>
                </Grid>

                <Grid item>
                    <Button
                        variant="contained"
                        startIcon={<Save />}
                        // disabled={!prevent && !openUpdate ? true : false}
                        size="small"
                        style={
                            (inshst.safe.iconBtn,
                                { borderRadius: 0, backgroundColor:  "#008080"  })
                        }
                        className={[clasui.button]}
                        onClick={onSubmit}
                    >
                        {t("download")}
                    </Button>
                </Grid>


            </Grid>

        </React.Fragment>

    );

}